export default {
  id: '',
  name: 'No access',
}
